import { ProductGender } from '../products-matrix/product-gender.enum';
import { ProductMainGroups } from '../products-matrix/product-main-groups.enum';

export class DraftProductModel {
  /**
   * item number of the product
   * @example '29.99866'
   */
  public name: string;
  /**
   * Name of the product with version number, but without color
   * @example 'Cloudflow 3'
   */
  public productGroupName: string;
  /**
   * Full product name description with size color and size
   * @example 'Cloudstratus 1 Navy | Dust W 8.5'
   */
  public description: string;
  /**
   * also called product barcode or EAN code
   */
  public productId: string;

  public lineId: string;
  public quantity: number;
  public unitPrice: number;
  public totalPrice?: number;
  public lineItemNumber: number;
  public unitDiscount: number;

  /**
   * Product category (main group), resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public mainGroup?: ProductMainGroups;

  /**
   * Product gender, resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public gender?: ProductGender;

  /** Launch date, resolved server-side from the product catalog by barcode. */
  public launchDate?: string | Date;
}
